export default __webpack_public_path__ + "static/media/mailjet-logo.f6a9f9b6.png";